import {colorSwatch} from '../utils/colorSwatch.js';
import React from 'react';
import {MenuButton} from '../components/menu-button.js';

import {Container, PanelProps} from '@wonderlandengine/react-ui/components';
import {Align, PositionType} from '@wonderlandengine/react-ui';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';
import {leaveCredits} from '../utils/goToCredits.js';

export const CreditsPanel = (props: React.PropsWithChildren<PanelProps> & {}) => {
    return (
        <Container
            width="100%"
            maxWidth={1000}
            position={PositionType.Absolute}
            bottom={10}
            left={20}
        >
            <MenuButton
                alignSelf={Align.Center}
                width={250}
                height={70}
                margin={6}
                color={colorSwatch.CancelButton}
                fontSize={28}
                icon={UiTexturesManager.instance.arrow}
                rotation={180}
                iconWidth={38}
                iconHeight={40}
                onClick={() => {
                    leaveCredits();
                }}
            >
                {Localization.instance.get('LoseProgressDialogReject')}
            </MenuButton>
        </Container>
    );
};
